import type { SubEnvironment } from '@change-corgi/config/environments';

import { facebookAppIds } from './data';

export function getFacebookAppId(environment: SubEnvironment): string {
	// eslint-disable-next-line security/detect-object-injection
	return facebookAppIds[environment];
}
